import React from 'react';
import { Link } from 'react-router-dom';
import { LockIcon, RotateCcwIcon, ShieldCheckIcon } from 'lucide-react';
const items = [{
  icon: ShieldCheckIcon,
  title: 'Lifetime warranty',
  body: 'On every system of 4+ lights',
  to: '/warranty'
}, {
  icon: RotateCcwIcon,
  title: '30-day returns',
  body: 'From the day it arrives',
  to: '/returns'
}, {
  icon: LockIcon,
  title: 'Secure checkout',
  body: '256-bit SSL encrypted',
  to: null
}];

/** Risk-reversal row shown directly under the system selector. */
export function GuaranteeStrip() {
  return <ul className="mt-6 grid border-y mf-hairline sm:grid-cols-3" data-id="element-869" data-mp="3vzfeqs6zo2v4">
      {items.map(({
      icon: Icon,
      title,
      body,
      to
    }, i) => {
      const inner = <>
            <Icon className="h-6 w-6 shrink-0 text-marine" aria-hidden data-id="element-870" data-mp="9qxq46tvksci" />
            <span data-id="element-871" data-mp="1g6q8oxuirxx8">
              <span className="block font-display text-lg font-semibold uppercase tracking-[0.06em] text-white" data-id="element-872" data-mp="1g55fpcnusn1h">{title}</span>
              <span className="block text-sm text-titanium" data-id="element-873" data-mp="1l3godk2ewri4">{body}</span>
            </span>
          </>;
      const cls = `flex items-center gap-4 px-1 py-5 sm:px-6 ${i > 0 ? 'border-t mf-hairline sm:border-l sm:border-t-0' : ''}`;
      return <li key={title} data-id="element-874" data-mp="3kj96n7o7rur2" data-mpi={i}>
            {to ? <Link to={to} className={`${cls} transition-colors duration-150 hover:bg-white/[0.03] focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-ice`} data-id="element-875" data-mp="3km54kw02ajfi">
                {inner}
              </Link> : <div className={cls} data-id="element-876" data-mp="35ucsqtzh7nij">{inner}</div>}
          </li>;
    })}
    </ul>;
}